import { createSelector } from 'reselect';
const getBoxscore = (state) => {
    return state.boxscore;
};

export const getBoxscoreState = createSelector(
    [getBoxscore],
    (boxscore) => ({
        boxscore
    })
);
